<div class="setup-wrapper">
    <app-breadcrumb></app-breadcrumb>

    <div class="setup-container  localization-container editprofile-container" style="padding: 16px;">



        <div class="setup-right">

            <div class="flex edit-profile-nav">
                <a href="javascript:void(0)" class="active" [routerLink]="['/../../editprofile']"> {{'Profile.user.Profile' | translate}} </a>
                <a href="javascript:void(0)" [routerLink]="['/../../change-password']">  {{'Profile.user.Password' | translate}}</a>
            </div>

            <form novalidate [formGroup]="editProfileForm">
                <div class="flex editprofilerow">

                    <div class="epr-img">
                        <img [src]="image" onError="this.src='./assets/img/avatar-img1.png';" style="width: 100%; height: 100%">
                        <a href="javascript:void(0)">
                            <input type="file" #filePath (change)="docufile($event)"> Change
                        </a>
                    </div>
                    <!--  -->

                    <div class="epr-frm">

                        <div class="suprs-form">
                            <div class="suprs-form-row flex">
                                <label> {{'Profile.Auth.Name' | translate}} <a href="javascript:void(0)">
                                     </a>  </label>
                                <div class="suprs-form-col">
                                    <input type="text" placeholder="Name" formControlName="name" [ngClass]="{'validationcolor':editProfileForm.get('name').hasError('required') && editProfileForm.get('name').touched  &&ifSubmitted==true}" class="form-control" />
                                    <div class="error" *ngIf="(editProfileForm.get('name').hasError('required') && editProfileForm.get('name').touched)  &&ifSubmitted==true">
                                        {{'Profile.Error.NameRequired' | translate}}
                                    </div>
                                    <div class="error" *ngIf="(editProfileForm.get('name').hasError('pattern') && editProfileForm.get('name').touched)  &&ifSubmitted==true">

                                        {{'Profile.Error.IncorrectUserEmail' | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="suprs-form">
                            <div class="suprs-form-row flex">
                                <label> {{'Profile.Auth.Email' | translate}} <a href="javascript:void(0)"> 
                                 </a>  </label>
                                <div class="suprs-form-col">
                                    <input type="text" class="form-control" placeholder="{{'Profile.Auth.Email' | translate}} " formControlName="email" [ngClass]="{'validationcolor':editProfileForm.get('email').hasError('required') && editProfileForm.get('email').touched  &&ifSubmitted==true}"
                                    />

                                    <div class="error" *ngIf="(editProfileForm.get('email').hasError('required') && editProfileForm.get('email').touched)  &&ifSubmitted==true">
                                        {{'Profile.Error.EmailRequired' | translate}}
                                    </div>
                                    <div class="error" *ngIf="(editProfileForm.get('email').hasError('pattern') && editProfileForm.get('email').touched)  &&ifSubmitted==true">

                                        {{'Profile.Error.IncorrectEmail' | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="suprs-form">
                            <div class="suprs-form-row flex">
                                <label>{{'Profile.Auth.PhoneNumber' | translate}}  <a href="javascript:void(0)"> 
                                 </a>  </label>
                                <div class="suprs-form-col">
                                    <input type="text" class="form-control" maxlength="10" appOnlyNumber placeholder="{{'Profile.Auth.PhoneNumber' | translate}}" formControlName="phone" [ngClass]="{'validationcolor':editProfileForm.get('phone').hasError('required') && editProfileForm.get('phone').touched  &&ifSubmitted==true}"
                                    />
                                    <div class="error" *ngIf="(editProfileForm.get('phone').hasError('required') && editProfileForm.get('phone').touched)  &&ifSubmitted==true">
                                        {{'Profile.Error.PhoneNumberRequired' | translate}}
                                    </div>
                                    <div class="error" *ngIf="(editProfileForm.get('phone').hasError('pattern') && editProfileForm.get('phone').touched)  &&ifSubmitted==true">
                                        {{'Profile.Error.IncorrectNumber' | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="suprs-form">
                            <div class="suprs-form-row flex">
                                <label>{{'Profile.Auth.Address' | translate}}  <a href="javascript:void(0)"> 
                                </a>  </label>
                                <div class="suprs-form-col">
                                    <textarea class="form-control" rows="2" placeholder="{{'Profile.Auth.Address' | translate}}" formControlName="address" [ngClass]="{'validationcolor':editProfileForm.get('address').hasError('required') && editProfileForm.get('address').touched  &&ifSubmitted==true}"></textarea>
                                    <div class="error" *ngIf="(editProfileForm.get('address').hasError('required') && editProfileForm.get('address').touched)  &&ifSubmitted==true">
                                        {{'Profile.Error.Addressrequired' | translate}}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex srbtn">
                            <button class="cancel" (click)="editprofileCancel()">{{'Settings.Local.Country.Cancel' | translate}}</button>
                            <button (click)="save(editProfileForm.value)">{{'Settings.Local.Save' | translate}}</button>
                        </div>

                    </div>
                    <!-- center -->

                    <div class="set-lay-notes flex">
                        <h4>Note :</h4>
                        <p>Quid ex eo ortum, tam inportuno tamque crudeli; sin, ut de commodis suis. Tum dicere exorsus est consecutus? laudem et ultimum bonorum, quod maxime consuevit iactare. Alii autem, quibus ego cum soluta nobis est consecutus? laudem
                            et aut petat. In oculis quidem faciunt, ut dolore suo sanciret militaris imperii disciplinam exercitumque in.</p>
                    </div>

                </div>
            </form>


        </div>



    </div>
</div>